// TODO label 수정에 대한 값 저장 리팩토링 가능한지 체크, 현재 존재하지 않으면 label만 변경하였을때 값이 저장되지 않음
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { TextField, Tooltip } from 'next-common-lib';
import i18n from 'i18n';

export const TextFieldHookForm = ({
  name,
  maxLength,
  componentType,
  className,
  width,
  height,
  disabled,
  autoFocus,
  placeholderLabel,
  label,
  useExpLabel,
  readonly,
  timerCount,
  timerCallback,
  restrictCallback,
  error,
  useTooltip,
  tooltipComponentType,
  tooltipTitle,
  tooltipLabels,
  tooltipPlacement,
  autoComplete,
}) => {
  const {
    control,
    trigger,
    resetField,
    formState: { errors },
  } = useFormContext();

  const {
    field: { onChange, onBlur, value },
    fieldState: { invalid },
  } = useController({
    name,
    control,
    defaultValue: label,
  });

  const getTextField = () => {
    return (
      <TextField
        id={name}
        label={value}
        componentType={componentType}
        onChange={onChange}
        onBlur={onBlur}
        onDelete={() => {
          resetField(name);
          trigger(name);
        }}
        error={errors[name] || error}
        maxLength={isNaN(maxLength) ? '' : maxLength}
        className={className}
        width={width}
        height={height}
        disabled={disabled}
        readonly={readonly}
        autoFocus={autoFocus}
        useExpLabel={useExpLabel}
        placeholderLabel={placeholderLabel}
        timerCount={timerCount}
        timerCallback={timerCallback}
        onRestrict={restrictCallback}
        validation={!invalid}
        failLabel={i18n.t(errors[name]?.message)}
        autoComplete={autoComplete}
      />
    );
  };

  if (useTooltip) {
    return (
      <Tooltip
        componentType={tooltipComponentType}
        title={tooltipTitle}
        label={tooltipLabels}
        placement={tooltipPlacement}
      >
        {getTextField()}
      </Tooltip>
    );
  }
  return <>{getTextField()}</>;
};

TextFieldHookForm.propTypes = {
  name: PropTypes.string.isRequired,
  maxLength: PropTypes.number.isRequired,
  componentType: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  disabled: PropTypes.bool,
  useExpLabel: PropTypes.bool,
  autoFocus: PropTypes.bool,
  placeholderLabel: PropTypes.string,
  label: PropTypes.string,
  readonly: PropTypes.bool,
  timerCount: PropTypes.string,
  timerCallback: PropTypes.func,
  restrictCallback: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  useTooltip: PropTypes.bool,
  tooltipComponentType: PropTypes.string,
  tooltipTitle: PropTypes.string,
  tooltipLabels: PropTypes.object,
  tooltipPlacement: PropTypes.string,
  autoComplete: PropTypes.string,
};
TextFieldHookForm.defaultProps = {
  componentType: 'input',
  className: '',
  width: null,
  height: null,
  disabled: false,
  useExpLabel: true,
  autoFocus: false,
  placeholderLabel: '',
  label: '',
  readonly: false,
  timerCount: '',
  error: false,
  timerCallback: () => {},
  restrictCallback: () => {
    return true;
  },
  useTooltip: false,
  tooltipComponentType: 'hover',
  tooltipTitle: '',
  tooltipLabels: [],
  tooltipPlacement: 'bottom-start',
  autoComplete: 'on',
};
export default TextFieldHookForm;
